module.exports = __webpack_public_path__ + "static/media/baseMeme10.961f29bf.jpg";